import { purchaseOrderIdFormat } from "@redotech/redo-inventory-id";
import * as z from "zod";
import { PurchaseOrderFileSchema_ } from "./get-purchase-order";

export const addPurchaseOrderFile = {
  name: "addPurchaseOrderFile" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    title: z.string(),
  }),
  output: z.object({ file: PurchaseOrderFileSchema_ }),
};
